import {defineStore} from 'pinia'
import {CommonNs, ContainerNs} from "@shared/types";
import {ContainerApi} from "@/api";


export const useContainerStore = defineStore("container", {
    state: () => ({
        containerList: [] as ContainerNs.Container[],
    }),
    getters: {
        getContainerList: (state): ContainerNs.Container[] => state.containerList,
    },
    actions: {
        setContainerList(data: ContainerNs.Container[]): void {
            this.containerList = data.sort((a, b) => a.id - b.id);
        },

        async loadContainers(payload: ContainerNs.GetContainerRequest): Promise<ContainerNs.Container[]> {
            return ContainerApi.getContainerList(payload)
                .then((containerList) => {
                    this.setContainerList(containerList);
                    return containerList;
                })
        },

        async addContainer(payload: ContainerNs.AddContainerRequest): Promise<ContainerNs.Container[]> {
            return ContainerApi.addContainer(payload)
                .then((containerList) => {
                    this.setContainerList(containerList);
                    return containerList;
                })
        },

        async changedContainerName(payload: ContainerNs.ChangeContainerNameRequest): Promise<CommonNs.GenericResponse> {
            return ContainerApi.changeContainerName(payload)
                .then((response) => response)
        },

        async removedContainer(payload: ContainerNs.RemoveContainerRequest): Promise<ContainerNs.Container[]> {
            return ContainerApi.removeContainer(payload)
                .then((containerList) => {
                    this.setContainerList(containerList);
                    return containerList;
                })
        },

        removedProjectFromContainer(containerId: number, projectId: string) {
            const container = this.containerList.find((container) => container.id === containerId);
            if (container) {
                container.projectList.splice(container.projectList.findIndex((p) => p.id === projectId), 1)
            }
        },

        moveProjectToContainer(fromContainer: number, toContainer: number, projectId: string) {
            const fContainer = this.containerList.find((container) => container.id === fromContainer);
            const tContainer = this.containerList.find((container) => container.id === toContainer);
            if (fContainer && tContainer) {
                const project = fContainer.projectList.find((p) => p.id === projectId)
                if(project) {
                    fContainer.projectList.splice(fContainer.projectList.findIndex((p) => p.id === projectId), 1)
                    tContainer.projectList.push(project);
                }
            }
        },
    }
});
